import React from 'react'
import {

    WideScreenContainer, 
} from 'components/elements'

import PurpleAnimHeader from 'components/PurpleAnimHeader';
// import ViewAll from 'components/ViewAll';

import FooterAnimation from 'components/FooterAnimation'
import LoadingHoc from '../../hoc/LoadingHOC'
import { NewslettersPageWrap } from './elements';
// import useRememberScrollPosition from "../../hooks/useRememberScrollPosition";
import ExploreOtherNewsletters from 'components/ExploreOtherNewsletters';



function Newsletters(props) {

	const {setLoading} = props		 //receive the loading trigger change function from the HOC


	React.useEffect(() => {

			setTimeout(() => {
				setLoading(false)
			}, 500)

		// eslint-disable-next-line
	}, [])
	
	return (
		<NewslettersPageWrap className="pageWrapper">
			{/* <Helmet>
				<title>{seoData.title}</title>
				<link rel="canonical" href={window.location.pathname}/>
				<meta name="description" content={seoData.description}/>
				<meta name="og:description" content={seoData.description}/>
				<meta name="og:title" content={seoData.title}/>
				<meta name="og:url"
					  content={window.location.protocol + "//" + window.location.host + window.location.pathname}/>
				<meta name="og:type" content="website"/>
				<meta name="og:site_name" content="Real Chemistry"/>

				<meta name="og:image" content={window.location.protocol + seoData.image}/>
				<meta name="og:image:type" content={"image/" + seoData?.mimeType}/>
				<meta name="og:image:width" content={seoData?.seoImageWidth}/>
				<meta name="og:image:height" content={seoData?.seoImageHeight}/>
			</Helmet> */}

			<PurpleAnimHeader
                sectionLabel={"Newsletters"}
                sectionTitle={undefined}
				heroIntro={undefined}
				headerSplit={"2"}
                backgroundImage={"/images/newsletters-header-dsktop.png"}
				backgroundImgMbl={"/images/newsletters-header-mbl.png"}
				backgroundImgTitle={""}
                header={"Let’s make a connection"}
				introCopy={"Transforming healthcare isn’t for the faint of heart. And it certainly can’t be done alone. Our newsletters connect you with the leaders, insights and ideas that are raising the bar on the modern healthcare experience."}
                titleMdPadding={"25% 0 0"}
				maxWidth={"30%"}
				marginRight={"15%"}
				maxHeight={"700px"}
				headerMaxWidth="40%"

            />
			<WideScreenContainer>
				<ExploreOtherNewsletters/>
			</WideScreenContainer>

			<FooterAnimation
				svgDesktop="/images/purple-footer.svg"
				svgMobile="/images/purple-footer-mbl.svg"
				borderTop="none"
			/>
		</NewslettersPageWrap>
	)
}

// Wrap the component with LoadingHOC and send in the component.

export default LoadingHoc(Newsletters)
